/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as t from "react";
import e from "./base/ConfigurationComponent.mjs";
const a = (o) => /* @__PURE__ */ t.createElement(e, { ...o, _mapKey: "tooltip" });
export {
  a as MapMarkerLayerTooltip
};
